// Simple confetti animation for celebration
const confetti = () => {
  const duration = 3 * 1000;
  const animationEnd = Date.now() + duration;
  const colors = ['#de2910', '#ffde00', '#ff6b9d', '#ff69b4'];

  const randomInRange = (min, max) => {
    return Math.random() * (max - min) + min;
  };

  const createConfettiPiece = () => {
    const confettiPiece = document.createElement('div');
    const size = Math.floor(Math.random() * 10) + 5;
    const left = Math.random() * window.innerWidth;
    const animationDuration = randomInRange(2, 4);
    const color = colors[Math.floor(Math.random() * colors.length)];
    
    confettiPiece.style.position = 'fixed';
    confettiPiece.style.left = left + 'px';
    confettiPiece.style.top = '-20px';
    confettiPiece.style.width = size + 'px';
    confettiPiece.style.height = size + 'px';
    confettiPiece.style.backgroundColor = color;
    confettiPiece.style.borderRadius = Math.random() > 0.5 ? '50%' : '0';
    confettiPiece.style.pointerEvents = 'none';
    confettiPiece.style.zIndex = '9999';
    confettiPiece.style.transform = `rotate(${Math.random() * 360}deg)`;
    
    // CSS animation
    confettiPiece.style.animation = `fall ${animationDuration}s linear`;
    
    document.body.appendChild(confettiPiece);
    
    setTimeout(() => {
      confettiPiece.remove();
    }, animationDuration * 1000);
  };

  // Create style element for animation
  const style = document.createElement('style');
  style.innerHTML = `
    @keyframes fall {
      to {
        transform: translateY(${window.innerHeight + 20}px) rotate(720deg);
      }
    }
  `;
  document.head.appendChild(style);

  // Create confetti pieces
  const interval = setInterval(() => {
    if (Date.now() < animationEnd) {
      createConfettiPiece();
      createConfettiPiece();
      createConfettiPiece();
    } else {
      clearInterval(interval);
      // Clean up style element after animation
      setTimeout(() => {
        style.remove();
      }, 4000);
    }
  }, 150);
};

export default confetti;


